import React from 'react';
import { connect } from 'react-redux';
import { fetchClientsWithFilters, getUsersInAccount } from 'api';
import { sendSocketEmit, notify, requestUpdateTask } from 'actions';
import { DatePicker, LoadingSpinner, ClientSelect } from 'components';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  Row,
  Col,
  ButtonGroup,
  Button
} from 'react-bootstrap';
import Select from 'react-select';
import moment from 'moment';

class TaskForm extends React.Component {
  constructor(props) {
    super(props);

    const {
      assigned_to,
      text,
      due_date,
      reminder_date,
      client
    } = this.props.task || {};

    this.state = {
      assigned_to: assigned_to ? assigned_to._id : this.props.users.user._id,
      text: text || '',
      due_date: due_date || new Date(),
      reminder_date: reminder_date || null,
      reminder_time: reminder_date ? moment(reminder_date).utc().format('HH:mm') : '00:00',
      selected_client: client ? client._id : null,

      selecting_reminder_date: false,
      fetching_users: true,
      users_in_account: [],

      reset_reminder: false
    };

    this.mounted = false;

    this.getClientOptions = this.getClientOptions.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  getClientOptions(input) {
    return fetchClientsWithFilters({
      size: 20,
      filters: [
        { type: 'owners', value: this.props.users.user._id },
        { type: 'name', value: input }
      ]
    })
    .then(clients => ({ options: clients.results.map(c => ({ value: c._id, label: c.name })) }))
    .catch(ex => console.log(ex));
  }
  handleSave() {
    let reminder_date = null;
    if(this.state.reminder_date) {
      const reminder_date_moment = moment(this.state.reminder_date).utc();
      const hour = this.state.reminder_time.substr(0, 2);
      const minute = this.state.reminder_time.substr(3);
      reminder_date_moment.set({ hour, minute });
      reminder_date = reminder_date_moment.toDate();
    }
    const { selected_client } = this.state;
    const payload = {
      assigned_to: this.state.assigned_to,
      text: this.state.text,
      due_date: new Date(this.state.due_date),
      reminder_date,
      client: selected_client && selected_client.value ? selected_client.value : selected_client,
    }
    if(this.props.task && this.props.task._id) {
      this.props.requestUpdateTask({ ...payload, _id: this.props.task._id });
    }
    else {
      this.props.sendSocketEmit(payload, 'task-new');
    }
    this.props.cancel();
  }
  componentDidMount() {
    this.mounted = true;
    const payload = {
      size: 500,
      filters: [ { type: 'owners', value: this.props.users.user._id } ]
    };
    Promise.all([
      getUsersInAccount(),
      fetchClientsWithFilters(payload)
    ])
    .then(([ users, clients ]) => {
      this.users_in_account = users;
      const { results } = clients;
      if(this.mounted) {
        this.setState({
          current_clients_list: results.map(c => ({ value: c._id, label: c.name })),
          users_in_account: users.map(u => ({ value: u._id, label: `${u.name.first || ''} ${u.name.last || ''}` })),
          fetching_users: false
        });
      }
    })
    .catch(e => this.props.notify(e.message || e));
  }
  componentWillUpdate() {
    if(this.state.reset_reminder) {
      this.setState({ reset_reminder: false });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { user } = this.props.users;
    return (
      <div className='task-form-container'>
        <div>
          <FormGroup>
            <h6>Description</h6>
            <FormControl
              id='task-description'
              placeholder='Description'
              value={this.state.text}
              onChange={e => this.setState({ text: e.target.value })}
              componentClass='textarea'
            />
            <h6>Assigned User</h6>
            <Select
              options={this.state.users_in_account}
              onChange={u => this.setState({ assigned_to: (u && u.value ? u.value : this.props.users.user._id) })}
              value={this.state.assigned_to}
              placeholder='Select user ...'
              isLoading={this.state.fetching_users}
              className='assigned-user-select'
            />
            <h6>Client</h6>
            <Select.Async
              value={this.state.selected_client}
              onChange={client => this.setState({ selected_client: client })}
              loadOptions={this.getClientOptions}
              className='task-form-client-select'
            />

          </FormGroup>
          <ButtonGroup justified style={{ marginTop: '33px' }}>
            <Button
              bsStyle={!this.state.selecting_reminder_date ? 'primary' : 'default'}
              onClick={() => this.setState({ selecting_reminder_date: false })}
              >
              Due Date
            </Button>
            <Button
              bsStyle={this.state.selecting_reminder_date ? 'primary' : 'default'}
              onClick={() => this.setState({ selecting_reminder_date: true })}
              >
              Reminder
            </Button>
          </ButtonGroup>
          <div className='tasks-form-calendar-container task-calendar'>
            {this.state.selecting_reminder_date ? (
              <div>
                {this.state.reset_reminder ? (
                  <DatePicker
                    key='task-form-reset'
                    weekNumbers={false}
                    dark
                  />
                ) : (
                  <DatePicker
                    key='task-form-reminder-date-calendar'
                    weekNumbers={false}
                    defaultDate={this.state.reminder_date}
                    defaultActiveDate={this.state.reminder_date}
                    defaultViewDate={this.state.reminder_date}
                    dark
                    onChange={d => this.setState({ reminder_date: d })}
                  />
                )}
                <div className='task-form-reminder-time-input-container'>
                  <Row>
                    <Col md={6} xs={6} className='task-reminder-time'>
                      <input
                        type='time'
                        className='form-control'
                        onChange={e => this.setState({ reminder_time: e.target.value })}
                        value={this.state.reminder_time}
                      />
                    </Col>
                    <Col md={6} xs={6} className='task-reminder-clear'>
                      <Button
                        onClick={() => this.setState({ reminder_date: null, reminder_time: '12:00', reset_reminder: true })}
                        block
                        style={{ marginTop: '0px' }}
                        >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            ) : (
              <DatePicker
                key='task-form-due-date-calendar'
                dark
                weekNumbers={false}
                defaultDate={this.state.due_date}
                defaultActiveDate={this.state.due_date}
                defaultViewDate={this.state.due_date}
                onChange={d => this.setState({ due_date: d })}
              />
            )}
          </div>
          <div className='task-form-buttons-container'>
            <Button block bsStyle='success' onClick={this.handleSave}>
              {this.props.tasks.updating_task ? <LoadingSpinner /> : 'Save'}
            </Button>
            <Button block onClick={this.props.cancel}>Cancel</Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ users, tasks }) => ({ users, tasks });

export default connect(mapStateToProps, { sendSocketEmit, notify, requestUpdateTask })(TaskForm);



// WEBPACK FOOTER //
// ./src/browser/components/tasks/new-tasks/task-form.js